import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["price"]
  
  connect() {
    // Initialize prices from data attribute
    this.prices = JSON.parse(this.element.dataset.prices)
  }

  updatePrice(event) {
    const selectedUnitId = event.target.value
    const unitPrice = this.prices[selectedUnitId] || ""
    this.priceTarget.value = unitPrice
  }
}
